var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMCnt4Dialog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 97,
    viewBox: "0 0 238 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6173 15.3428C34.5861 -5.11426 94.6795 -5.11426 117.648 15.3428C132.961 28.9808 132.961 43.6762 117.648 57.3143C111.558 62.739 102.856 66.7252 92.929 69.2729L102.351 79.233C102.419 79.3045 102.353 79.4204 102.257 79.3994L70.7177 72.5103C48.0184 73.6086 24.2251 68.5433 11.6173 57.3143C-3.69533 43.6762 -3.69533 28.9808 11.6173 15.3428Z",
    fill: "url(#paint0_linear_2136_7070)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8794 33.3388C83.7804 31.2699 86.8626 31.2699 88.7637 33.3388C90.6647 35.4078 90.6647 38.7622 88.7637 40.8312C86.8626 42.9002 83.7804 42.9002 81.8794 40.8312C79.9783 38.7622 79.9783 35.4078 81.8794 33.3388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9751 33.3388C61.8761 31.2699 64.9583 31.2699 66.8594 33.3388C68.7604 35.4078 68.7604 38.7622 66.8594 40.8312C64.9583 42.9002 61.8761 42.9002 59.9751 40.8312C58.074 38.7622 58.074 35.4078 59.9751 33.3388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0688 33.3388C39.9699 31.2699 43.0521 31.2699 44.9531 33.3388C46.8542 35.4078 46.8542 38.7622 44.9531 40.8312C43.0521 42.9002 39.9699 42.9002 38.0688 40.8312C36.1678 38.7622 36.1678 35.4078 38.0688 33.3388Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.121 32.5498C203.152 12.0928 143.059 12.0928 120.09 32.5498C104.777 46.1879 104.777 60.8833 120.09 74.5213C126.181 79.946 134.882 83.9322 144.809 86.4799L135.387 96.44C135.32 96.5115 135.385 96.6275 135.481 96.6065L167.021 89.7173C189.72 90.8157 213.513 85.7503 226.121 74.5213C241.434 60.8833 241.434 46.1879 226.121 32.5498Z",
    fill: "url(#paint1_linear_2136_7070)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.859 50.5478C153.958 48.4789 150.876 48.4789 148.975 50.5478C147.074 52.6168 147.074 55.9712 148.975 58.0402C150.876 60.1092 153.958 60.1092 155.859 58.0402C157.76 55.9712 157.76 52.6168 155.859 50.5478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.763 50.5478C175.862 48.4789 172.78 48.4789 170.879 50.5478C168.978 52.6168 168.978 55.9712 170.879 58.0402C172.78 60.1092 175.862 60.1092 177.763 58.0402C179.664 55.9712 179.664 52.6168 177.763 50.5478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.669 50.5478C197.768 48.4789 194.686 48.4789 192.785 50.5478C190.884 52.6168 190.884 55.9712 192.785 58.0402C194.686 60.1092 197.768 60.1092 199.669 58.0402C201.57 55.9712 201.57 52.6168 199.669 50.5478Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2136_7070",
    x1: 64.6328,
    y1: 21.2428,
    x2: 64.6079,
    y2: 39.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2136_7070",
    x1: 173.079,
    y1: 33.6938,
    x2: 173.211,
    y2: 101.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F271A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B0CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCnt4Dialog);
export default __webpack_public_path__ + "static/media/m_cnt4_dialog.f38f164ff4ae43030f3fc9441af8f7f3.svg";
export { ForwardRef as ReactComponent };